import React from 'react';

import { Button, Dialog, Text } from '@betterment/samba-react';

type Props = {
  recencyDescription: string;
  performanceDisclosure: string;
};

export const PerformanceDisclosure: React.FC<Props> = ({ recencyDescription, performanceDisclosure }) => {
  return (
    <Text variant="text25" color="text.weak">
      {recencyDescription} See{' '}
      <Dialog overlay="default">
        <Dialog.Trigger data-samba-component={true} asChild={true}>
          <Button variant="textSecondary">disclosure</Button>
        </Dialog.Trigger>
        <Dialog.Content
          css={{
            padding: 'space.400',
            width: '100%',
            maxWidth: 'container.xlarge',
            maxHeight: '80vh',
            overflow: 'auto',
          }}
        >
          <Text dangerouslySetInnerHTML={{ __html: performanceDisclosure }} />
          <Dialog.Close asChild={true}>
            <Button variant="solidSecondary" css={{ mt: 'space.300' }}>
              Close
            </Button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog>
    </Text>
  );
};
